import dayjs from 'dayjs'
import { useEffect, useState } from 'react'

import { getServerNow } from '@/components/entities/common/model/server-time'
import { DEFAULT_DATE_ONLY_FORMAT } from '@/components/entities/requests/model/constants'
import { toMskDayString } from '@/utils/datetime'

import { AppCheckboxBadged } from '../../../checkbox'

const SHORT_QUICK_FILTERS = [
  { label: 'Сегодня', value: 0 },
  { label: 'Завтра', value: 1 }
]

type Props = {
  date: Date
  today?: Date
  setDate: (date: Date) => void
}

export const ShortQuickFilters = ({ date, today, setDate }: Props) => {
  const [localDate, setLocalDate] = useState(date)

  useEffect(() => {
    setLocalDate(date)
  }, [date])

  const todayKey = today
    ? dayjs(today).format(DEFAULT_DATE_ONLY_FORMAT)
    : toMskDayString(getServerNow())

  const getFilterDateKey = (filterValue: number) =>
    dayjs(todayKey).add(filterValue, 'day').format(DEFAULT_DATE_ONLY_FORMAT)

  const isFilterActive = (filterValue: number) => {
    if (!localDate) {
      return filterValue === 0
    }

    return (
      dayjs(localDate).format(DEFAULT_DATE_ONLY_FORMAT) ===
      getFilterDateKey(filterValue)
    )
  }

  const applyDate = (dateKey: string) => {
    const selectedDate = dayjs(dateKey).toDate()

    setDate(selectedDate)
    setLocalDate(selectedDate)
  }

  const onQuickFilterClick = (filterValue: number) => {
    applyDate(getFilterDateKey(filterValue))
  }

  const resetDate = () => {
    applyDate(todayKey)
  }

  return (
    <div className="mt-8 flex gap-8">
      {SHORT_QUICK_FILTERS.map(filter => (
        <AppCheckboxBadged
          key={filter.value}
          checked={isFilterActive(filter.value)}
          onChange={event => {
            event.preventDefault()
            onQuickFilterClick(filter.value)
          }}
          onIconClick={resetDate}
          label={filter.label}
          dataTestId={`quick-day-${filter.value}-id`}
          closable={false}
        />
      ))}
    </div>
  )
}
